<template>
  <div class="edit_content">
    <div class="title">{{ editValue.title }}</div>
    <el-form ref="form" :rules="rules" :label-position="'top'" label-width="80px" :model="personalInfo">
      <div v-if="editObj.id==2">
        <div class="row_box">
          <el-form-item label="姓名" prop="name">
            <el-input placeholder="请输入您的姓名" v-model="personalInfo.name"></el-input>
          </el-form-item>
          <el-form-item label="当前求职状态" prop="statusValue">
            <el-select style="width: 100%;" v-model="personalInfo.statusValue" placeholder="请选择">
              <el-option v-for="item in jobStatusOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row_box">
          <el-form-item label="性别" prop="gender">
            <el-radio-group v-model="personalInfo.gender">
              <el-radio-button style="margin-right: 20px;" :label="1">男</el-radio-button>
              <el-radio-button :label="2">女</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="row_box">
          <el-form-item label="出生年月" prop="age">
            <el-date-picker value-format="yyyy-MM" style="width: 100%;" v-model="personalInfo.age" type="month" placeholder="选择出生日期" :picker-options="disableFutureMonths">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="电话" prop="telephone">
            <el-input placeholder="请输入您的电话" v-model="personalInfo.telephone"></el-input>
          </el-form-item>
        </div>
        <div class="row_box">
          <el-form-item label="参加工作时间" prop="workStart">
            <el-date-picker value-format="yyyy-MM" style="width: 100%;" v-model="personalInfo.workStart" type="month" placeholder="选择工作时间" :picker-options="disableFutureMonths" />
          </el-form-item>
          <el-form-item label="微信号（选填）">
            <el-input v-model="personalInfo.wechat" placeholder="请输入您的微信号"></el-input>
          </el-form-item>
        </div>
        <div class="row_box">
          <el-form-item label="邮箱（选填）">
            <el-input v-model="personalInfo.email" placeholder="请输入您的邮箱"></el-input>
          </el-form-item>
        </div>
      </div>
      <div v-if="editObj.id==3">
        <el-form-item label="" prop="personal_advantages">
          <el-input style="height: 240px;" type="textarea" :show-word-limit="true" placeholder="例如:两年UI设计经验，熟悉I0S和Android的界面设计规范，对产品本色有独特见解，有一定的手绘基础" v-model="personalInfo.personal_advantages"></el-input>
        </el-form-item>
      </div>

    </el-form>
    <div v-if="editObj.id === 4">
      <Expectedposition ref="positionRef" :edit="true" :experience="positionIndex === null ? null : personalInfo?.position[positionIndex]" />
    </div>

    <!-- 工作经历 -->
    <div v-if="editObj.id === 5">
      <WorkExperience ref="workExperienceRef" :edit="true" :experience="workExperienceIndex === null ? null : personalInfo?.work_experience[workExperienceIndex]"></WorkExperience>
    </div>
    <div v-if="editObj.id === 7">
      <Educationalbackground ref="educationRef" :edit="true" :experience="educationIndex === null ? null : personalInfo?.education_experience[educationIndex]"></Educationalbackground>
    </div>

    <!-- 项目经历 -->
    <div v-if="editObj.id === 6">
      <ProjectExperience ref="projectExperienceRef" :edit="true" :experience="projectExperienceIndex === null ? null : personalInfo?.project_experience[projectExperienceIndex]"></ProjectExperience>
    </div>

    <div class="footer_box">
      <el-button @click="cancal">取消</el-button>
      <el-button @click="beforeFinish('form')">完成</el-button>
    </div>
  </div>
</template>

<script>
import WorkExperience from "./components/WorkExperience.vue";
import ProjectExperience from "./components/ProjectExperience.vue";
import Educationalbackground from "./components/Educationalbackground.vue";
import Expectedposition from "./components/Expectedposition.vue";
export default {
  name: "",
  props: [
    "editObj",
    "info",
    "workExperienceIndex",
    "projectExperienceIndex",
    "educationIndex",
    "positionIndex",
  ],
  data() {
    return {
      personalInfo: {
        id: null,
        position_id: null,
        name: "",
        statusValue: null,
        status: null,
        gender: "",
        age: "",
        telephone: "",
        wechat: "",
        experience: "",
        email: "",
        workStart: "",
        educational_background: "",
        personal_advantages: "",
        type_job: 1,
        hope_position: "", //期望职位
        hop_industry: "", //期望行业
        salary_range: "",
        salary_min: null,
        salary_max: null,
        city_work: "",
        hope_city: "",
        work_experience: [],
        project_experience: [],
        hope_city_value: [],
        education_experience: [],
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        statusValue: [
          { required: true, message: "请选择当前求职状态", trigger: "change" },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        age: [{ required: true, message: "请选择出生年月", trigger: "change" }],
        workStart: [
          { required: true, message: "请选择参加工作时间", trigger: "change" },
        ],
        telephone: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的电话号码",
            trigger: "blur",
          },
        ],
        personal_advantages: [
          { required: true, message: "请输入个人优势", trigger: "blur" },
        ],
      },
      jobStatusOption: [
        {
          label: "离职-随时到岗",
          value: 1,
        },
        {
          label: "在职-暂不考虑",
          value: 2,
        },
        {
          label: "在职-考虑机会",
          value: 3,
        },
        {
          label: "在职-月内到岗",
          value: 4,
        },
      ],
      editValue: {
        title: "",
        id: null,
      },

      disableFutureMonths: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  components: {
    WorkExperience,
    ProjectExperience,
    Educationalbackground,
    Expectedposition,
  },

  mounted() {
    Object.assign(this.personalInfo, this.info);
    this.editValue.title =
      (!this.editObj.isValue ? "添加" : "编辑") + this.editObj.name; //false 是添加
    this.editValue.id = this.editObj.id;
  },
  methods: {
    cancal() {
      this.$emit("cancleEdit", this.editObj.id - 1);
    },
    beforeFinish(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.finish();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async finish() {
      this.personalInfo.status = this.personalInfo.statusValue
        ? this.jobStatusOption[this.personalInfo.statusValue - 1].label
        : null;
      if (this.editObj.id == 2) {
        this.personalInfo.experience =
          this.getYear(this.personalInfo.workStart) + "年工作经验";
      }
      //   const currentDate = new Date();
      //   if (this.personalInfo.workStart) {
      //     const targetDate2 = new Date(this.personalInfo.workStart);
      //     if (targetDate2 > currentDate) {
      //     }
      //   }
      // 期望职位
      if (this.editObj.id == 4) {
        const isVaild = await this.$refs.positionRef?.valid();
        if (!isVaild) return;
        let positionItem = this.$refs.positionRef?.formData;
        // 处理期望职位数据
        positionItem.other_city =
          positionItem.hope_city_value[positionItem.hope_city_value.length - 1];
        positionItem.city =
          positionItem.city_work_value[positionItem.city_work_value.length - 1];
        positionItem.name =
          positionItem.hope_position_value[
            positionItem.hope_position_value.length - 1
          ];
        let arr = [];
        positionItem.hop_industry_value.forEach((item) => {
          arr.push(item[item.length - 1]);
        });
        positionItem.industry = arr.join("、");
        this.$emit("finishEdit", positionItem, this.editObj.id - 1);
      }
      // 工作经历
      else if (this.editObj.id === 5) {
        if (!this.$refs.workExperienceRef?.valid?.()) return;
        const experienceItem = this.$refs.workExperienceRef?.formData;
        this.$emit("finishEdit", experienceItem, this.editObj.id - 1);
      }
      // 项目经历
      else if (this.editObj.id === 6) {
        if (!this.$refs.projectExperienceRef?.valid?.()) return;
        const experienceItem = this.$refs.projectExperienceRef?.formData;
        this.$emit("finishEdit", experienceItem, this.editObj.id - 1);
      }
      // 教育经历
      else if (this.editObj.id === 7) {
        if (!this.$refs.educationRef?.valid?.()) return;
        const educationItem = this.$refs.educationRef?.formData;
        this.$emit("finishEdit", educationItem, this.editObj.id - 1);
      } else {
        this.$emit("finishEdit", this.personalInfo, this.editObj.id - 1);
      }
    },

    getYear(time) {
      // 获取当前日期
      const currentDate = new Date();
      // 创建指定日期对象
      const targetDate = new Date(time);
      // 分别获取当前年份和目标年份
      const currentYear = currentDate.getFullYear();
      const targetYear = targetDate.getFullYear();
      // 计算年份差值
      let yearDifference = currentYear - targetYear;
      let arr = ["一", "二", "三", "四", "五", "六", "七"];
      if (yearDifference == 0) {
        yearDifference = "";
      } else {
        yearDifference = arr[yearDifference - 1]
          ? arr[yearDifference - 1]
          : yearDifference;
      }
      return yearDifference;
    },
  },
};
</script>
<style lang='scss' scoped>
.edit_content {
  width: 100%;
  background: #f8f8f8;
  border-radius: 12px 12px 12px 12px;
  padding: 24px 30px;
  box-sizing: border-box;
  .title {
    font-weight: bold;
    font-size: 18px;
    color: #232323;
    margin-bottom: 24px;
  }
  .el-form {
    .row_box {
      width: 100%;
      display: flex;
      .el-form-item {
        width: 400px;
        margin-right: 40px;
      }
    }
  }
  .footer_box {
    display: flex;
    .el-button {
      width: 88px;
      height: 36px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #232323;
      border: none;
      &:hover {
        color: #685ef5;
      }
      &:nth-child(2) {
        background: #685ef5;
        color: #fff;
      }
    }
  }
}
::v-deep .el-radio-button__inner {
  width: 190px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #dcdcdc;
  &:hover {
    color: #685ef5;
  }
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #f0efff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #685ef5;
  color: #685ef5;
}
::v-deep .el-textarea__inner {
  min-height: 240px !important;
}
</style>
